document.addEventListener('DOMContentLoaded', function () {

    gsap.registerPlugin(ScrollTrigger);

    gsap.to('.footer__img-anim', {
        y: -50,
        scrollTrigger: {
            trigger: '.footer',
            start: 'top 90%',
            end: 'bottom bottom',
            scrub: 1,
        }
    })

    const dataAnimationY = document.querySelectorAll('[data-y]');
    let end = 'top 10%';

    if (window.innerWidth < 768) {
        end = 'top 50%';
    }

    dataAnimationY.forEach(function (item) {
        gsap.from(item, {
            y: item.dataset.y,
            scrollTrigger: {
                trigger: item,
                start: 'top 90%',
                end: end,
                scrub: 2,
            }
        })
    });



    function headerHide() {
        const header = document.querySelector(".header");
        let scrolledWindow = scrollY;
        let scrollPrev = 0;

        if (scrolledWindow > 10) {
            header.classList.add('header-white');
        } else {
            header.classList.remove('header-white');
        }


        window.addEventListener('scroll', function () {
            let scrolled = scrollY;

            if (scrolled > 10) {
                header.classList.add('header-white');
            } else {
                header.classList.remove('header-white');
            }

            if (scrolled > 0 && scrolled > scrollPrev) {
                header.classList.add('header-hide');
            } else {
                header.classList.remove('header-hide');
            }
            scrollPrev = scrolled;
        });
    }

    if (document.querySelector(".header")) {
        headerHide();
    }






    const listItem = $('.nav ul >li');

    const subMenu = listItem.filter(function () {
        return $(this).find('.sub-menu').length;
    });

    $(subMenu).on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).find('.sub-menu').slideToggle(300);
    });










});

